export enum VideoCommentMenuEventType {
	Delete = 'Delete',
	Reply = 'Reply',
	ShowReplies = 'ShowReplies'
}
